module.exports = __webpack_public_path__ + "img/members-bg-shape@mb.2858412.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/members-bg-shape@mb.svg
// module id = g6D7
// module chunks = 0